import React, { Component } from 'react';
import { Layout, Avatar, Popover } from '@nackle/paper';
const { Header } = Layout;
// import { Link } from 'biw-web-router';
import { routeHistory } from '@nackle/biw-web-router';
import CompanySelect from '../company-select/company-select.jsx';
// import {
//   HomeOutlined,
//   SearchOutlined,
//   UploadOutlined
// } from '@ant-design/icons';

import './app-header.less';

class AppHeader extends Component {
  constructor( props ) {
    super( props );
    console.log( 'this.props.user', this.props.user );
    this.state = {
      user: this.props.user,
      companyId: this.props.companyId ? this.props.companyId : '',
      logo: ''
    };
  }
  componentDidMount() {
    this.props.loading();
  }
  companyChange( id ) {
    this.props.setCompanyId( id.companyId );
    this.setState( id );
    routeHistory.push( `/${ id.companyId }` );
  }

  setLogo( logo ) {
    this.setState( {
      logo
    } );
  }

  render() {
    const { companyId } = this.props;
    const profileContent = (
      <div className="ecardProfilePopup">
        <Avatar size={ 54 } className="card-mobile-hide ecard-profile-name">
          { this.state.user && this.state.user.claims
            ? this.state.user.claims.name.split( ' ' )[ 0 ].split( '' )[ 0 ] +
              this.state.user.claims.name.split( ' ' )[ 1 ].split( '' )[ 0 ]
            : '' }
        </Avatar>
        <div className="ecardAvatarName">
          <strong>
            { this.state.user && this.state.user.claims
              ? this.state.user.claims.name
              : '' }
          </strong>
          <p>
            { this.state.user && this.state.user.claims
              ? this.state.user.claims.email
              : '' }
          </p>
          <p className="logout-btn" onClick={ ()=>this.props.signOut() }>Logout</p>
        </div>
      </div>
    );

    return (
      <Header className="app-header">
        <div className="header-company-select">
          <CompanySelect
            companyId={ companyId }
            onChange={ ( company ) => {
              this.companyChange( {
                companyId: company.id
              } );
            } }
            isHeader={ true }
          ></CompanySelect>
        </div>
        <div className="user-container">
          <div className="user-action">
            <Popover
              placement="bottomRight"
              title={ profileContent }
              trigger="click"
            >
              <Avatar className="card-mobile-hide ecard-profile-name">
                { this.state.user && this.state.user.claims
                  ? this.state.user.claims.name.split( ' ' )[ 0 ].split( '' )[ 0 ] +
                    this.state.user.claims.name.split( ' ' )[ 1 ].split( '' )[ 0 ]
                  : '' }
              </Avatar>
            </Popover>
          </div>
        </div>
      </Header>
    );
  }
}

export default AppHeader;
